import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  themeName: 'Dark Theme',
  modal_centerAlign: {
    minWidth: '100px',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  modal_leftAlign: {
    textAlign: 'left',
  },
  palette: {
    type: 'dark',
    common: {
      black: '#000',
      white: '#fff',
    },
    background: {
      paper: '#2F3B42',
      default: '#262A2D',
      header: '#262A2D',
    },
    primary: {
      light: '#FFC482',
      main: '#F8992D',
      dark: '#DB811B',
      contrastText: '#fff',
    },
    secondary: {
      light: '#8EDCEE',
      main: '#45BDD8',
      dark: '#1E95AF',
      contrastText: '#fff',
    },
    // info: {},
    success: {
      main: '#8FE865',
    },
    warning: {
      main: '#F6C33F',
    },
    error: {
      main: '#E83A44',
    },
    paper: {
      light: '#586B76',
      main: '#2F3B42',
      dark: '#262A2D',
      device: '#262A2D',
    },
    table: {
      border: 'rgba(255,255,255, 0.2)',
      header: '#262A2D',
      headerText: 'white',
      row: '#2C353B',
    },
    typeColor: {
      graph: 'white',
      light: '#E5E5E5',
      main: 'white',
      dark: '#232323',
    },
    button: {
      action: '#262A2D',
      main: 'white',
    },
    calendar: {
      dates: '#262A2D',
      outOfRange: '#E5E5E5',
      inRange: '#DAF8FF',
      activeAds: '#45BDD8',
      recurringAds: '#EC8232',
      upcomingAds: '#262A2D',
      adTop: '#E32B4D',
      adBottom: '#E3BB2B',
    },
  },
  typography: {},
});

export const themeLight = createTheme({
  themeName: 'Light Theme',
  modal_centerAlign: {
    minWidth: '100px',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  modal_leftAlign: {
    textAlign: 'left',
  },
  palette: {
    type: 'light',
    common: {
      black: '#000',
      white: '#fff',
    },
    background: {
      paper: 'white',
      default: '#efefef',
      header: '#E5E5E5',
    },
    primary: {
      light: '#FFC482',
      main: '#F8992D',
      dark: '#DB811B',
      contrastText: '#fff',
    },
    secondary: {
      light: '#8EDCEE',
      main: '#45BDD8',
      dark: '#1E95AF',
      contrastText: '#fff',
    },
    // info: {},
    success: {
      main: '#8FE865',
    },
    warning: {
      main: '#F6C33F',
    },
    error: {
      main: '#E83A44',
    },
    paper: {
      light: '#586B76',
      main: '#2F3B42',
      dark: '#262A2D',
      device: '#2F3B42',
    },
    table: {
      border: 'rgba(0,0,0, 0.2)',
      header: '#2F3B42',
      headerText: 'white',
      row: '#E5E5E5',
    },
    typeColor: {
      graph: '#232323',
      light: '#E5E5E5',
      main: '#585858',
      dark: '#232323',
    },
    button: {
      action: 'white',
      main: '#262A2D',
    },
    calendar: {
      dates: '#262A2D',
      outOfRange: '#E5E5E5',
      inRange: '#DAF8FF',
      activeAds: '#45BDD8',
      recurringAds: '#EC8232',
      upcomingAds: '#262A2D',
      adTop: '#E32B4D',
      adBottom: '#E3BB2B',
    },
  },
  typography: {},
});
